import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M17.8625053,22.6069336 C19.3468803,22.6069336 20.228228,21.7441406 20.228228,20.3061523 L20.228228,12.0493164 L21.4621147,13.1811523 C21.7033256,13.4130859 22.0002006,13.5615234 22.334185,13.5615234 C22.9464897,13.5615234 23.4103569,13.144043 23.4103569,12.5595703 C23.4103569,12.2348633 23.3175835,11.9750977 23.0114311,11.6967773 L19.5417045,8.52392578 L19.5417045,2.84619141 C19.5417045,2.42871094 19.2726616,2.15966797 18.8459038,2.15966797 L17.1203178,2.15966797 C16.7028374,2.15966797 16.4152397,2.42871094 16.4152397,2.84619141 L16.4152397,5.67578125 L13.2980522,2.82763672 C12.8527397,2.41943359 12.3610405,2.21533203 11.8229545,2.21533203 C11.2848686,2.21533203 10.7931694,2.42871094 10.3571342,2.82763672 L0.634477983,11.6967773 C0.328325639,11.9750977 0.235552202,12.2348633 0.235552202,12.5595703 C0.235552202,13.144043 0.708696733,13.5615234 1.32100142,13.5615234 C1.6549858,13.5615234 1.94258345,13.4130859 2.18379439,13.1811523 L3.42695845,12.0493164 L3.42695845,20.3061523 C3.42695845,21.7441406 4.29902876,22.6069336 5.79268111,22.6069336 L17.8625053,22.6069336 Z M9.08613814,20.4824219 L6.42354048,20.4824219 C5.85762251,20.4824219 5.55147017,20.1669922 5.55147017,19.5917969 L5.55147017,10.1103516 L11.5631889,4.60888672 C11.6374077,4.54394531 11.7209038,4.49755859 11.8229545,4.49755859 C11.915728,4.49755859 12.0177788,4.52539062 12.0919975,4.60888672 L18.1037163,10.1103516 L18.1037163,19.5917969 C18.1037163,20.1669922 17.7882866,20.4824219 17.2223686,20.4824219 L14.559771,20.4824219 L14.559771,14.387207 C14.559771,13.9511719 14.2814506,13.6728516 13.8361381,13.6728516 L9.8190483,13.6728516 C9.3737358,13.6728516 9.08613814,13.9511719 9.08613814,14.387207 L9.08613814,20.4824219 Z" 
            />
        </svg>
    );

export default SVG;
